module.exports = __webpack_public_path__ + "img/cases-brand-avic-lazyload-311.96390742.jpg";